import styled from 'styled-components'

export const StyledToast = styled.div`
  .C-Heading {
    text-transform: capitalize;
  }
`
